import { render, staticRenderFns } from "./inventoriesWrite.vue?vue&type=template&id=6ce5a46e"
import script from "./inventoriesWrite.vue?vue&type=script&lang=js"
export * from "./inventoriesWrite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports